import OperationForm from "./OperationForm";
export default function Restitution() {
  return <OperationForm type="RESTITUTION" />;
}
